module.exports = __webpack_public_path__ + "static/media/1_square.1fac1eb2.png";